function t(t,u,n){return{isSuccessfull:t,data:u,status:n}}function u(u,n){return t(!0,u,n)}export{u as createSuccessFullResponse,t as default};
